import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import PropTypes from 'prop-types';
import rankedTagImg from '../../../assets/images/icons/ranked_tag.svg';
import './TagDisplay.scss';
var rankedTagTooltip = function rankedTagTooltip() {
  var ranking = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var location = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var mustHave = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return /*#__PURE__*/React.createElement(Tooltip, {
    className: "proficiency-ranking-tag-tooltip",
    id: "proficiency-ranking-tooltip"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "unindented-list"
  }, ranking && /*#__PURE__*/React.createElement("li", null, ' ', ranking ? 'Marked as top area by consultant' : '', ' '), location !== 'search' && /*#__PURE__*/React.createElement("li", null, "Matches project requirements"), mustHave && /*#__PURE__*/React.createElement("li", null, "Matches project must-have")));
};
var matchingTags = function matchingTags(matchingFrom, matchingAgainst, complex) {
  return matchingFrom.filter(function (t) {
    return matchingAgainst.includes(complex ? t.name : t);
  });
};
var TagDisplay = /*#__PURE__*/function (_Component) {
  function TagDisplay(props) {
    var _this;
    _classCallCheck(this, TagDisplay);
    _this = _callSuper(this, TagDisplay, [props]);
    var areRoles = _this.props.areRoles;
    _this.state = {
      roleTags: areRoles
    };
    _this.renderRoleTags = _this.renderRoleTags.bind(_this);
    _this.renderTagsSearch = _this.renderTagsSearch.bind(_this);
    _this.renderSingleTag = _this.renderSingleTag.bind(_this);
    _this.renderRecommendationTags = _this.renderRecommendationTags.bind(_this);
    return _this;
  }
  _inherits(TagDisplay, _Component);
  return _createClass(TagDisplay, [{
    key: "renderRoleTags",
    value: function renderRoleTags() {
      var consultant = this.props.consultant;
      if (consultant.higher_level_roles.length > 0) {
        return /*#__PURE__*/React.createElement("div", {
          id: "role-tag-group",
          className: "tags role-tags"
        }, /*#__PURE__*/React.createElement("div", {
          id: "roles-group",
          className: "tag-group"
        }, consultant.higher_level_roles.map(function (t) {
          return /*#__PURE__*/React.createElement("span", {
            id: "role-tag",
            key: t.name,
            className: "badge medium me-2"
          }, t.name.length > 40 ? "".concat(t.name.substring(0, 40), "...") : t.name, /*#__PURE__*/React.createElement("span", {
            className: "experience"
          }, t.experience));
        })));
      }
      return null;
    }
  }, {
    key: "renderTagsSearch",
    value: function renderTagsSearch(header, tags) {
      var location = this.props.location;
      if (tags.length > 0) {
        return /*#__PURE__*/React.createElement("div", {
          className: "tag-group"
        }, /*#__PURE__*/React.createElement("h4", {
          className: "medium-weight regular-spacing"
        }, header), tags.map(function (t) {
          return t.ranking ? /*#__PURE__*/React.createElement(OverlayTrigger, {
            placement: "top",
            overlay: rankedTagTooltip(t.ranking, location, false)
          }, /*#__PURE__*/React.createElement("span", {
            key: t,
            className: "badge small me-2"
          }, t.ranking && /*#__PURE__*/React.createElement("img", {
            className: "me-3",
            src: rankedTagImg,
            alt: "Top Tag",
            height: "14",
            width: "10"
          }), t.name ? t.name : t, /*#__PURE__*/React.createElement("span", {
            className: "experience"
          }, t.experience))) : /*#__PURE__*/React.createElement("span", {
            key: t,
            className: "badge small me-2"
          }, t.name ? t.name : t, /*#__PURE__*/React.createElement("span", {
            className: "experience"
          }, t.experience));
        }));
      }
      return null;
    }
  }, {
    key: "renderSingleTag",
    value: function renderSingleTag(tag, rank, experience) {
      var _this$props = this.props,
        location = _this$props.location,
        priorityTags = _this$props.priorityTags,
        seniorityTags = _this$props.seniorityTags;
      var isPriority = priorityTags.includes(tag);
      var mustHave = seniorityTags.includes(tag) || isPriority;
      return /*#__PURE__*/React.createElement(OverlayTrigger, {
        placement: "top",
        overlay: rankedTagTooltip(rank, location, isPriority)
      }, /*#__PURE__*/React.createElement("span", {
        id: "recommendation-tag",
        key: tag,
        className: "badge small ".concat(rank ? 'proficiency ' : '', " ").concat(mustHave ? 'purple-base ' : '', "  me-2")
      }, rank && /*#__PURE__*/React.createElement("img", {
        className: "me-3 ".concat(mustHave ? 'white-icon' : ''),
        src: rankedTagImg,
        alt: "Top Tag",
        height: "14",
        width: "10"
      }), tag, /*#__PURE__*/React.createElement("span", {
        id: "years",
        className: "experience ".concat(mustHave ? 'highlighted ' : '')
      }, experience)));
    }
  }, {
    key: "renderRecommendationTags",
    value: function renderRecommendationTags() {
      var _this2 = this;
      var _this$props2 = this.props,
        consultant = _this$props2.consultant,
        seniorityTags = _this$props2.seniorityTags,
        priorityTags = _this$props2.priorityTags,
        nonPriorityTags = _this$props2.nonPriorityTags;
      var projectTags = [].concat(_toConsumableArray(priorityTags), _toConsumableArray(nonPriorityTags));
      var matchedSeniorities = matchingTags(consultant.seniority_levels, seniorityTags, false);
      var matchedExpertise = matchingTags(consultant.area_of_expertises, projectTags, true);
      var matchedTherapeuticAreas = matchingTags(consultant.therapeutic_areas, projectTags, true);
      var matchedTherapies = matchingTags(consultant.therapies, projectTags, true);
      var matchedDiseases = matchingTags(consultant.diseases, projectTags, true);
      var matchedPhases = matchingTags(consultant.development_phases, projectTags, false);
      return /*#__PURE__*/React.createElement("div", {
        id: "recommendation-tags",
        className: "tag-group"
      }, matchedSeniorities.map(function (t) {
        return _this2.renderSingleTag(t, false, '');
      }), matchedExpertise.map(function (t) {
        return _this2.renderSingleTag(t.name, false, t.experience);
      }), matchedTherapeuticAreas.map(function (t) {
        return _this2.renderSingleTag(t.name, t.ranking, t.experience);
      }), matchedTherapies.map(function (t) {
        return _this2.renderSingleTag(t.name, t.ranking, t.experience);
      }), matchedDiseases.map(function (t) {
        return _this2.renderSingleTag(t.name, t.ranking, t.experience);
      }), matchedPhases.map(function (t) {
        return _this2.renderSingleTag(t, false, '');
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        location = _this$props3.location,
        consultant = _this$props3.consultant;
      var roleTags = this.state.roleTags;
      if (roleTags) {
        return this.renderRoleTags();
      }
      return /*#__PURE__*/React.createElement("div", null, location === 'search' && /*#__PURE__*/React.createElement("div", {
        id: "recommendation-tag-group",
        className: "tags"
      }, this.renderTagsSearch('Therapeutic areas', consultant.therapeutic_areas), this.renderTagsSearch('Product Technologies', consultant.therapies), (consultant.therapeutic_areas.length === 0 || consultant.therapies.length === 0) && this.renderTagsSearch('Phases of development', consultant.development_phases)), location !== 'search' && /*#__PURE__*/React.createElement("div", {
        className: "tags"
      }, this.renderRecommendationTags()));
    }
  }]);
}(Component);
TagDisplay.propTypes = {
  consultant: PropTypes.shape({}).isRequired,
  location: PropTypes.string,
  seniorityTags: PropTypes.arrayOf(PropTypes.string),
  priorityTags: PropTypes.arrayOf(PropTypes.string),
  nonPriorityTags: PropTypes.arrayOf(PropTypes.string),
  areRoles: PropTypes.bool
};
TagDisplay.defaultProps = {
  location: '',
  areRoles: false
};
export default TagDisplay;